<template>
  <div class="pagination">
    <b-button
      id="first-page-button"
      class="direction-button"
      size="sm"
      pill
      variant="outline-primary"
      :disabled="isFirstPageNumber"
      @click="onClickDirection(0)"
    >
      <b-icon icon="chevron-double-left" />
    </b-button>
    <b-button
      id="prev-page-button"
      class="direction-button"
      size="sm"
      pill
      variant="outline-primary"
      :disabled="isFirstPageNumber"
      @click="onClickDirection(-1)"
    >
      <b-icon icon="chevron-left" />
    </b-button>

    <span class="page-number page-number-left current"> {{ currentPage }} </span>

    <div class="separator" />

    <span class="page-number page-number-right">
      {{ lastPageNumber }}
    </span>

    <b-button
      id="next-page-button"
      class="direction-button"
      size="sm"
      pill
      variant="outline-primary"
      :disabled="isLastPageNumber"
      @click="onClickDirection(1)"
    >
      <b-icon icon="chevron-right" />
    </b-button>
    <b-button
      id="last-page-button"
      class="direction-button"
      size="sm"
      pill
      variant="outline-primary"
      :disabled="isLastPageNumber"
      @click="onClickDirection(lastPageNumber)"
    >
      <b-icon icon="chevron-double-right" />
    </b-button>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "pagination",
})
export default class Pagination extends Vue {
  @Prop() public pageSize!: number;
  @Prop() public totalElements!: number;
  @Prop({ default: 1 }) public currentPage!: number;

  constructor() {
    super();
  }

  get lastPageNumber(): number {
    return Math.ceil(this.totalElements / this.pageSize);
  }

  get isFirstPageNumber(): boolean {
    return this.currentPage === 1;
  }

  get isLastPageNumber(): boolean {
    return this.currentPage === this.lastPageNumber;
  }

  onClickDirection(factor: number): void {
    let page = this.currentPage;
    if (factor === 0) {
      page = 1;
    } else if (factor === this.lastPageNumber) {
      page = this.lastPageNumber;
    } else if (factor > 0) {
      page++;
    } else if (factor < 0) {
      page--;
    }

    this.$emit("change", page);
  }
}
</script>

<style lang="scss" scoped>
.pagination {
  margin: 1rem 0;
  justify-content: flex-end;
}
.direction-button {
  padding: 2px;
  width: 24px;
  height: 24px;
  object-fit: contain;
  font-size: 0.8rem;
  line-height: 0.8rem;
  color: var(--amarillo-prosegur);
  background-color: #f3f3f3;
  border-color: #f3f3f3;

  &.disabled,
  &:disabled {
    color: #d5d5d5;
  }

  &:not(.disabled):not(:disabled) {
    &:hover {
      color: #212529;
      background-color: var(--amarillo-prosegur);
      border-color: var(--amarillo-prosegur);
    }
    &:active {
      color: #212529;
      background-color: var(--amarillo-prosegur-plus-60);
      border-color: var(--amarillo-prosegur-plus-60);
    }
  }
}

.separator {
  width: 0.5px;
  height: 22px;
  margin: 0 7px;
  background: #d5d5d5;
}

.page-number {
  height: 14px;
  margin: 4px 4px;
  opacity: 0.7;
  font-size: 0.8rem;
  line-height: 1rem;
  color: var(--secundario-prosegur-oscuro);
}

.page-number-left {
  margin-left: 10px;
}

.page-number-right {
  margin-right: 10px;
}

.current {
  opacity: 1;
  color: var(--amarillo-prosegur-plus-20);
}
</style>
